import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((orderItem, index) => {
        const orderItems = orderItem.Order_items;
        const pictures = orderItem.Pictures;
        if (orderItems && Array.isArray(orderItems)) {
          orderItems.forEach((item) => {
            const row = {
              id: index,
              picture: pictures?.map((picture) => ({
                id: picture.id,
                picture: picture.pic
                  .split("http")
                  .filter(Boolean)
                  .map((url) => `http${url.trim()}`),
              })),
              product_id: item.product_id,
              product_code: orderItem.product_code,
              product_name: orderItem.product_name,
              category_id: orderItem.category_id,
              product_type: orderItem.product_type || "",
              detail: orderItem.detail,
              blemishes: orderItem.blemishes,
              size: orderItem.size,
              price: orderItem.price,
              total_price: orderItem.total_price,
              total_amount: orderItem.total_amount,
              created_date: moment(orderItem.created_date).format(
                "DD/MM/YYYY\n เวลา HH:mm:ss น."
              ),
              updated_date: moment(orderItem.updated_date).format(
                "DD/MM/YYYY\n เวลา HH:mm:ss น."
              ),
              return_date: orderItem.return_date
                ? moment(orderItem.return_date).format(
                    "DD/MM/YYYY\n เวลา HH:mm:ss น."
                  )
                : null,
              order_id: item.order_id,
              order_item_id: item.id,
              remaining_amount: orderItem.remaining_amount,
              notes: orderItem.notes,
            };

            rows.push(row);
          });
        }
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
